import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Box, Button, styled, SxProps, Theme, Typography } from '@mui/material'

import { FileRemove } from 'elements/FileUpload/common/commonInterfaces'
import { concatToSXProp } from 'utils/style'
import truncateText from 'utils/truncateText'

import { imagePreviewBox } from '../common/styles'

interface ImagePreviewProps extends FileRemove {
  src: string
  name: string
  isOnline: boolean
}

const Image = styled('img')(() => ({
  width: '100%',
  aspectRatio: '1/1',
  borderRadius: 8,
  objectFit: 'cover',
}))

const styles: Record<string, SxProps<Theme>> = {
  wrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imgText: {
    padding: 0.5,
    fontSize: '11px !important',
    wordBreak: 'break-word',
  },
  removeButtonStyles: {
    position: 'absolute',
    top: '-12px',
    right: '-12px',
    minWidth: 'unset',
    padding: 0,
    backgroundColor: 'rgba(255,255,255, 0.8) !important',
    borderRadius: '50%',
    color: (theme) => theme.palette.text.secondary,
  },
}

export default function ImagePreview({
  src,
  onRemove,
  isOnline,
  name,
}: ImagePreviewProps): JSX.Element {
  const { wrap, imgText, removeButtonStyles } = styles
  return (
    <Box className="file-upload-file" sx={concatToSXProp(imagePreviewBox, wrap)}>
      {isOnline ? (
        <Image src={src} alt={name} />
      ) : (
        <Typography sx={imgText}>{truncateText(name, 28)}</Typography>
      )}
      <Button onClick={onRemove} sx={removeButtonStyles}>
        <HighlightOffIcon />
      </Button>
    </Box>
  )
}
